/**
 * Referral Code Handler
 *
 * Automatically populates the referral code field in the register form
 * when a ?referral= parameter exists in the URL.
 *
 * This enhances the user experience by pre-filling referral codes from
 * invitation links without requiring manual copy/paste.
 */

(function() {
  'use strict';

  /**
   * Extract referral code from URL parameters
   * @returns {string|null} The referral code or null if not present
   */
  const getReferralCodeFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('referral');
  };

  /**
   * Populate the referral code field
   * @param {string} referralCode - The referral code to populate
   * @returns {boolean} True if field was found and populated, false otherwise
   */
  const populateReferralField = (referralCode) => {
    const referralField = document.querySelector('[data-cf-column-key="referral_code_1"]');

    if (!referralField) {
      return false;
    }

    // Check if field is an input element or contains an input
    const inputElement = referralField.tagName === 'INPUT'
      ? referralField
      : referralField.querySelector('input');

    if (inputElement) {
      // HELIUM CUSTOMER FIELDS SPECIFIC METHOD
      // Helium uses React, so we need to trigger React's internal event handlers

      // Get the native input value setter
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        'value'
      ).set;

      // Set the value using the native setter (bypasses React)
      nativeInputValueSetter.call(inputElement, referralCode);

      // Create and dispatch a native input event that React will pick up
      const inputEvent = new Event('input', { bubbles: true });

      // Add the necessary properties that React expects
      Object.defineProperty(inputEvent, 'target', {
        writable: false,
        value: inputElement
      });

      // Dispatch the event
      inputElement.dispatchEvent(inputEvent);

      // Also trigger change event
      const changeEvent = new Event('change', { bubbles: true });
      inputElement.dispatchEvent(changeEvent);

      // Trigger blur to ensure React state is updated
      setTimeout(() => {
        inputElement.dispatchEvent(new Event('blur', { bubbles: true }));
      }, 100);

      return true;
    }

    return false;
  };


  /**
   * Initialize referral code handling
   */
  const initReferralCodeHandler = () => {
    const referralCode = getReferralCodeFromUrl();

    if (!referralCode) {
      return; // No referral code in URL, nothing to do
    }

    // Try to populate immediately first
    const immediateSuccess = populateReferralField(referralCode);

    if (immediateSuccess) {
      return;
    }

    // Field not found yet, set up MutationObserver to watch for it
    const observer = new MutationObserver(() => {
      const referralField = document.querySelector('[data-cf-column-key="referral_code_1"]');

      if (referralField) {
        observer.disconnect(); // Stop observing once we found it
        populateReferralField(referralCode);
      }
    });

    // Start observing the register drawer for changes
    const registerDrawer = document.querySelector('x-drawer#register');

    if (registerDrawer) {
      observer.observe(registerDrawer, {
        childList: true,
        subtree: true
      });

      // Set a timeout to stop observing after 10 seconds
      setTimeout(() => {
        observer.disconnect();
      }, 10000);
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReferralCodeHandler);
  } else {
    initReferralCodeHandler();
  }

})();

